import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicOfferingRoutingModule } from './public-offering-routing.module';
import { PublicOfferingComponent } from './public-offering.component';
import { httpTranslateLoader } from '../core/core.module';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { HomeFooterComponent } from './home-footer/home-footer.component';
@NgModule({
  declarations: [
    PublicOfferingComponent,
    DetailComponent,
    HomeComponent,
    HomeFooterComponent
  ],
  imports: [
    CommonModule,
    PublicOfferingRoutingModule,
    RouterModule,
    SharedModule,
    FormsModule,
    NgbModule,
    TranslateModule.forChild({
      loader: {
      provide: httpTranslateLoader,
      useFactory: httpTranslateLoader,
      deps: [HttpClient]
    },
    isolate: false
    }),
  ]
})
export class PublicOfferingModule { }
